<template>
  <v-tooltip top class="help-tooltip">
    <template v-slot:activator="{ on }">
      <v-icon v-on="on" class="helpIcon" :class="{'tooltip-icon-inline': inline}">
        help_outline
      </v-icon>
    </template>
    <span><slot/></span>
  </v-tooltip>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {Prop} from "vue-property-decorator";

@Component({
  components: {}
})
export default class HelpTooltip extends BasicComponent {

  @Prop(Boolean) inline: boolean;

}

</script>
<style lang="scss" scoped>

.helpIcon {
  cursor: help;
}

</style>
<style lang="scss">

.tooltip-icon-inline {
  display: inline !important;
}

</style>